/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const GarantiertGeliefertCoolingLevel = {
    NO_COOLING: 0,
    COOLING_4_TO_8: 1,
    FROZEN_MINUS_12: 2,
    FROZEN_MINUS_18: 3
};
